import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { DeleteBoardUserRequest } from '../types';

export const deleteBoardUser = async ({
  pathParams: { organisationId, boardId, userId },
}: DeleteBoardUserRequest) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/users/${userId}`;
  await apiAuthClient.delete(url);
};
